module.exports = __webpack_public_path__ + "static/media/starFilled.f0b16431.png";